export default "__VITE_ASSET__c2a495a9__"